import React from "react";
import { useNavigate } from "react-router-dom";
import ChevronRight from "sushiweb/Icons/all/ChevronRight";
import getHexColor from "utils/getHexColor";
import { Card, VerticalLine } from "../Common/styles.common";
import {
  CardWrapper,
  GrnCardStatusFooter,
  GrnCardStatusTag,
  GrnCardTopTags,
} from "./styles.grn";

const viewDetailsIconStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "32px",
  height: "32px",
  borderRadius: "50%",
  border: "1px solid #E6E9EF",
};

export const GrnCard = ({ grn, source }) => {
  const navigate = useNavigate();

  const grnCardTags = grn?.grn_page_data?.header_tags || [];
  const grnCardFooter = grn?.grn_page_data?.footer;

  const handleViewDetailsCTA = () => {
    const tab = source === "all" ? "all" : "list";
    navigate(`/grn/details/${tab}/${grn.purchase_order_id}/${grn.id}`);
  };

  const handleCardKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleViewDetailsCTA();
    }
  };

  return (
    <Card
      className="mt-4 mx-4"
      onClick={handleViewDetailsCTA}
      onKeyDown={handleCardKeyDown}
      role="button"
      tabIndex={0}
      style={{ cursor: "pointer" }}
    >
      {grnCardTags.length > 0 && (
        <GrnCardTopTags>
          {grnCardTags.map((tag, index) =>
            tag?.text ? (
              <GrnCardStatusTag
                key={`${tag.text}-${index}`}
                $background={getHexColor(tag?.bg_color)}
                $text_color={getHexColor(tag?.color)}
              >
                <span className="fs-12 fw-600">{tag.text}</span>
              </GrnCardStatusTag>
            ) : null
          )}
        </GrnCardTopTags>
      )}

      <div className="d-flex justify-content-between align-items-start ml-4 mr-4">
        <div className="d-flex flex-column">
          <span className="fs-18 fw-700">{grn?.grn_number}</span>
          <span className="fs-12 fw-400 text-gray-cool mt-1">
            {grn?.supplier_bill_number
              ? `Invoice: ${grn.supplier_bill_number}`
              : null}
          </span>
        </div>
        <div style={viewDetailsIconStyle}>
          <ChevronRight size={20} color="#EF4F5F" />
        </div>
      </div>

      <CardWrapper bgColor="#F2F4F7" className="align-items-center mx-4 mt-4">
        <Card smallRadius className="wd-100 align-items-center">
          <div className="d-flex wd-100 justify-content-center">
            <div className="d-flex wd-50 flex-column align-items-center">
              <span className="fs-15 fw-700">
                &#8377;{grn?.supplier_bill_amount?.toLocaleString("en-IN")}
              </span>
              <span className="fs-13 fw-400 text-gray-cool mt-1">
                Invoice Amount
              </span>
            </div>
            <VerticalLine />
            <div className="d-flex wd-50 flex-column align-items-center">
              <span className="fs-15 fw-700">
                &#8377;{grn?.grn_amount?.toLocaleString("en-IN")}
              </span>
              <span className="fs-13 fw-400 text-gray-cool mt-1">
                GRN Amount
              </span>
            </div>
          </div>
        </Card>
        <span className="fs-12 fw-400 text-gray-cool m-3">
          GRN done on {grn?.grn_page_data?.grn_completed_on_date_str}
        </span>
      </CardWrapper>

      {grnCardFooter && (
        <GrnCardStatusFooter
          $text_color={getHexColor(grnCardFooter.color)}
          $bg={getHexColor(grnCardFooter.bg_color)}
        >
          <span className="fs-12 fw-600">{grnCardFooter.text}</span>
        </GrnCardStatusFooter>
      )}
    </Card>
  );
};

export default GrnCard;
